import { FC, ReactElement } from 'react';

import redFlag from 'assets/brand/red-flag@2x.png';
import Modal from 'components/_core/Modal';

interface TeamMemberModalProps {
  isOpen: boolean;
  description: string | string[];
  title: string | string[];
  footer: ReactElement;
}

const TeamMemberModal: FC<TeamMemberModalProps> = ({
  description,
  footer,
  isOpen,
  title,
}) => {
  return (
    <Modal isOpen={isOpen}>
      <Modal.Body>
        <Modal.Image src={redFlag} width="144px" />

        <Modal.Title>{title}</Modal.Title>

        <Modal.Description paddingBottom="space-32">
          {description}
        </Modal.Description>
      </Modal.Body>

      <Modal.Footer justifyContent="space-between">{footer}</Modal.Footer>
    </Modal>
  );
};

export default TeamMemberModal;
